module.exports = __webpack_public_path__ + "static/crosshatch-medium-b2792bf119bdb38a1d9bc196050f86b3.svg";